module.exports = __webpack_public_path__ + "img/ADD_TO_PATH.bec77584.png";